export default function TableOrderButtonsDirective() {
	return {
		template: require('./table-order-buttons.html'),
		transclude: true,
		restrict: 'AE',
		scope: {
			values: '=',
			index: '@'
		},
		controller: function($scope, $element, $attrs, arrayUtil) {
			'ngInject';
			this.moveTop = function() {
				arrayUtil.toTop(this.values, this.index);
			};

			this.moveBottom = function() {
				arrayUtil.toBottom(this.values, this.index);
			};

			this.moveUp = function() {
				arrayUtil.swapItems(this.values, this.index, this.index - 1);
			};

			this.moveDown = function() {
				arrayUtil.swapItems(this.values, this.getIndex(), this.getIndex() + 1);
			};

			this.getIndex = function() {
				return parseInt(this.index);
			};

			this.disableDown = function() {
				return this.getIndex() === this.values.length - 1;
			};

			this.disableUp = function() {
				return this.getIndex() === 0;
			};
		},
		controllerAs: 'vm',
		bindToController: true
	};
}
